import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/GenericNotFound.scss';

function GenericNotFound(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="generic-not-found-page">
      <h1 className="title">Nothing here</h1>
      <p className="description">
        Unfortunaly, the page you're looking for doesn't exist
      </p>
      <div className="nav-menu">
        <ul>
          <li>
            <NavLink to="/home">Alnair home</NavLink>
          </li>
          <li>
            <NavLink to="/gallery">Gallery</NavLink>
          </li>
          {/* <li>
            <NavLink to="/how-it-works">How it works</NavLink>
          </li> */}
          <li>
            <NavLink to="/contact-us">Contact us</NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default GenericNotFound;
